import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { MoreHorizontal } from "lucide-react";
import { sendLoginInvite } from "@/api/sendLoginInvite";
import { toast } from "@/hooks/useToast";

interface UserManagementActionMenuProps {
  employeeUuid: string;
  onEdit: (uuid: string) => void;
  hideEditButton?: boolean;
}

const UserManagementActionMenu: React.FC<UserManagementActionMenuProps> = ({
  employeeUuid,
  onEdit,
  hideEditButton = false,
}) => {
  const [isSendingInvite, setIsSendingInvite] = useState(false);

  const handleSendInvite = async () => {
    setIsSendingInvite(true);
    try {
      const response = await sendLoginInvite(employeeUuid);
      toast({ title: "Login invite", description: response.data.message });
    } finally {
      setIsSendingInvite(false);
    }
  };

  // If edit button is hidden and there are no other actions, don't render the menu at all
  if (hideEditButton) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="h-8 w-8 p-0 hover:bg-gray-200 transition-colors"
          variant="ghost"
        >
          <span className="sr-only">Open menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px] p-2 bg-white">
        <DropdownMenuItem
          className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
          onClick={() => onEdit(employeeUuid)}
        >
          Edit User
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
          disabled={isSendingInvite}
          onClick={handleSendInvite}
        >
          Send Login Invite
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserManagementActionMenu;
